// extracted by mini-css-extract-plugin
module.exports = {"focused":"DoneBtn_focused__19SKI","doneBtnContainer":"DoneBtn_doneBtnContainer__2TSoh","icon":"DoneBtn_icon__3bLhR","disabled":"DoneBtn_disabled__2BrZN"};